import { Serializable, jsonProperty } from "ts-serializable"

class CirculationPlaceItem extends Serializable {
  @jsonProperty(Number, null)
  public id: number | null = null

  @jsonProperty(String, null)
  public name = ""
}

export default CirculationPlaceItem
